export default __webpack_public_path__ + "static/media/zoneOff.c794796e.svg";